import { ReactNode } from 'react';
import { Card } from 'shared/components/ui/Card';
import { cn } from 'shared/utils/cn';

interface PanelProps {
  title: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}

/** Bloco de visualização de uma área (gráfico, composição, lista). */
export function Panel({ title, subtitle, actions, children, className }: PanelProps) {
  return (
    <Card className={cn('flex min-w-0 flex-col gap-4 p-5 sm:p-6', className)}>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="font-heading font-semibold text-ink">{title}</h3>
          {subtitle && <p className="mt-0.5 text-sm text-ink-secondary">{subtitle}</p>}
        </div>
        {actions}
      </div>
      {children}
    </Card>
  );
}
